/**
 * Maps an array of data items to a template.
 * @param {Array} results
 * @param {jQuery} $itemTemplate
 * @return {Element[]}
 */
const mapReferenceDataToTemplate = (results, $itemTemplate) =>
    results.map((entry) => {
        const $item = $itemTemplate.clone();
        $item.find('[data-sector]').text(entry.sector);
        $item.find('[data-title]').text(entry.title);
        $item.find('[data-text]').text(entry.text);
        $item
            .find('[data-img]')
            .attr('src', entry.img.replace('/home/10013_ansorg.com//w', ''));
        $item.find('[data-url]').attr('href', entry.url);

        return $item.get(0);
    });

export default mapReferenceDataToTemplate;



// WEBPACK FOOTER //
// ./src/scripts/components/search/mapReferenceDataToTemplate.js